const types = {
  // ========================================== Old
  SET_CHARTS_BAR: 'SET_CHARTS_BAR',
  SET_VERTICAL_COLUMNS: 'SET_VERTICAL_COLUMNS',
  SET_INVITES: 'SET_INVITES',
  SET_ANSWERS: 'SET_ANSWERS',
  SET_CLIENTS: 'SET_CLIENTS',
  SET_ANSWERS_BY_PHONE: 'SET_ANSWERS_BY_PHONE',
  SET_ANSWERS_BY_EMAIL: 'SET_ANSWERS_BY_EMAIL',
  SET_ANSWERS_BY_MANUAL: 'SET_ANSWERS_BY_MANUAL',
  SET_NPS_BY_DATE: 'SET_NPS_BY_DATE',
  SET_REPORTS_BASIC_COLUMNS: 'SET_REPORTS_BASIC_COLUMNS',
  SET_ASSESSMENTS: 'SET_ASSESSMENTS',
  SET_CATEGORIES: 'SET_CATEGORIES',
  SET_INDICATORS: 'SET_INDICATORS',
  SET_CSAT: 'SET_CSAT',
  SET_EMOTION: 'SET_EMOTION',
  SET_LIKEDISLIKE: 'SET_LIKEDISLIKE',
  // ========================================== end Old
  SET_NPS_EVOLUTION: 'SET_NPS_EVOLUTION',
  SET_ANSWERS_EVOLUTION: 'SET_ANSWERS_EVOLUTION',
  SET_INVITES_EVOLUTION: 'SET_INVITES_EVOLUTION',
  PERCENTAGE_EVOLUTION: 'PERCENTAGE_EVOLUTION',
  SET_COMPARATIVE_ACTIONS: 'SET_COMPARATIVE_ACTIONS',
  SET_CSAT_DATA: 'SET_CSAT_DATA',
  SET_EMOTION_DATA: 'SET_EMOTION_DATA',
  SET_LIKE_DISLIKE_DATA: 'SET_LIKE_DISLIKE_DATA',
  SET_LIKERT: 'SET_LIKERT',
  SET_REVIEWS: 'SET_REVIEWS',
  SET_REPORT_CATEGORIES: 'SET_REPORT_CATEGORIES',
  SET_REPORT_TAGS: 'SET_REPORT_TAGS',
  SET_REPORTS_EMOTIONS: 'SET_REPORTS_EMOTIONS',
  SET_WORDCLOUD: 'SET_WORDCLOUD',
  SET_REQUEST_PARAMS: 'SET_REQUEST_PARAMS',
  SET_FILTER_RANKINGS: 'SET_FILTER_RANKINGS',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/charts/mutations-types.js